import { useEffect, useState } from "react";
import { authConfig, type AuthConfig } from "../api/auth";

/**
 * What this server offers before sign-in. Optimistic about signup (the server
 * refuses it anyway when closed) and pessimistic about email (a button that
 * cannot work should not appear), until the server answers; and the same if it
 * cannot be asked.
 */
export function useAuthConfig(): AuthConfig {
  const [cfg, setCfg] = useState<AuthConfig>({
    signup_enabled: true, email_flows_enabled: false, account_services_enabled: false, signup_requires_approval: false,
  });
  useEffect(() => {
    let live = true;
    authConfig().then((c) => { if (live) setCfg(c); }).catch(() => {});
    return () => { live = false; };
  }, []);
  return cfg;
}
